import { AccessTokenManager } from '@spotify-internal/access-token';
import { accessTokenManager } from '@mrkt/features/auth';
import { getSpotifyClientId, getHash, getVersion } from '../env';

export const defaultWebgateHeaders = {
  accept: 'application/json',
  'content-type': 'application/json',
  'spotify-app-version': `${getVersion()}.${getHash()}`.trim(),
  'app-platform': 'Browser',
};

export const WEBGATE_DOMAIN = `https://generic.wg.spotify.com`;

export { accessTokenManager };

export const anonymousAccessTokenManager = AccessTokenManager.createAnonymous(
  getSpotifyClientId(),
);

export async function webgateFetch(
  input: RequestInfo,
  init?: RequestInit,
  anonymous?: boolean,
) {
  const req = new Request(input, init);
  const token = anonymous
    ? await anonymousAccessTokenManager.get()
    : await accessTokenManager.get();

  for (const [key, value] of Object.entries(defaultWebgateHeaders)) {
    if (!req.headers.has(key)) req.headers.set(key, value);
  }

  if (token) {
    req.headers.set('authorization', `Bearer ${token}`);
  } else {
    req.headers.delete('authorization');
  }
  return fetch(req);
}

/**
 * Convenience method that calls webgateFetch, verifies an
 * OK response was returned and extracts JSON from the body.
 */
export async function webgateFetchJson(
  input: RequestInfo,
  init?: RequestInit,
  anonymous?: boolean,
) {
  const response = await webgateFetch(input, init, anonymous);

  if (!response.ok) {
    throw new Error(`${response.status} ${response.url}`);
  }

  return await response.json();
}
